import Truststore from './Truststore';

export default Truststore;
